import React, { useState } from 'react';
import './index.scss';
import { CLIENTS } from '../../utils/basic';

const Banner = ({ pathPrefix = '' }: { pathPrefix?: string }) => {
  const [show, setShow] = useState(true);

  const getDomainName = () => {
    const isValidClient = CLIENTS.includes(pathPrefix.toLowerCase());
    return isValidClient ? pathPrefix : 'lashbrookdesigns';
  };

  if (pathPrefix === 'helzberg' && !show) {
    return (
      <div className="tw-h-10 tw-px-6 tw-flex-grow-0 tw-shrink-0 tw-flex tw-items-center tw-absolute tw-z-[5]">
        <a href="https://www.helzberg.com/">
          <img className="brand-logo-secondary" alt="logo" />
        </a>
      </div>
    );
  }

  return (
    <>
      {show && (
        <>
          <div className="tw-h-10 tw-px-6 tw-bg-brand-color tw-flex-grow-0 tw-shrink-0 tw-flex tw-justify-center sm:tw-justify-between tw-items-center tw-text-tertiary-color tw-text-sm tw-relative secondary-font-family">
            <a href={`https://www.${getDomainName()}.com/`} className="tw-hidden sm:tw-inline-block">
              <img className="brand-logo" alt="logo" />
            </a>
            <p>FREE at-home sizing kit with every order!</p>
            <p />
            <i
              className="fa-sharp fa fa-xmark tw-text-base tw-cursor-pointer close-icon"
              onClick={() => setShow(false)}
            ></i>
          </div>
          <a href={`https://www.${getDomainName()}.com/`} className="tw-inline-block sm:tw-hidden">
            <img className="brand-logo-secondary" alt="logo" />
          </a>
        </>
      )}
    </>
  );
};

export default Banner;
